import React, { useState, useEffect, useContext } from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import KskLogo from './logoKSK.png';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import HomeIcon from '@mui/icons-material/Home';
import HelpIcon from '@mui/icons-material/Help';
import AuthService from "../../services/auth.service";
import LogoutIcon from '@mui/icons-material/Logout';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import LocaleContext from '../../LocaleContext';
import TranslateIcon from '@mui/icons-material/Translate';
import { useTranslation } from "react-i18next";
import i18n from '../../i18n';

 function MainNavigation() {
  const { locale } = useContext(LocaleContext);
  const [currentUser, setCurrentUser] = useState(undefined);

  const { t } = useTranslation("common");

  function changeLocale(l) {
    if (locale !== l) {
      i18n.changeLanguage(l);
    }
  }

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setCurrentUser(user);
    }
  }, []);
  const logOut = () => {
    AuthService.logout();
  };

   return (
     <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}
          >
            <img alt="ksk logo" src={KskLogo} width="200"/>
          </IconButton>
          <Typography variant="h7" component="div" sx={{ flexGrow: 1 }}>
            {t('toolbar.panel')}
          </Typography>
          {!currentUser && (<Button href='/' color="inherit" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} startIcon={<HomeIcon />}>{t('toolbar.login')}</Button>) }
           {(currentUser) && (<Button href='/parkings' color="inherit" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} startIcon={<LocalParkingIcon />}>{t('toolbar.parking')}</Button>)}
           <Button href='/Help' color="inherit" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} startIcon={<HelpIcon />}>{t('toolbar.help')}</Button>
           {currentUser && (<Button href='/' color="inherit" onClick={logOut} sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} startIcon={<LogoutIcon />} >{t('toolbar.logout')} ({currentUser.username})</Button>)   }
           {!currentUser && (<Button href='/register' color="inherit" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} startIcon={<AssignmentIndIcon />} >{t('toolbar.rejestration')}</Button>)   }

          {!currentUser && (<Button href='/' color="inherit" sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} startIcon={<HomeIcon />}></Button>) }
          {currentUser && (<Button href='/parkings' color="inherit" sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} startIcon={<LocalParkingIcon />}></Button>)}
          <Button href='/Help' color="inherit" sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} startIcon={<HelpIcon />}></Button>
          {currentUser && (<Button href='/' color="inherit" onClick={logOut} sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} startIcon={<LogoutIcon />} ></Button>)   }
          {!currentUser && (<Button href='/register' color="inherit" sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} startIcon={<AssignmentIndIcon />} ></Button>)  }

          {!(locale === 'en') && <Button onClick={() => changeLocale('en')} color="inherit" sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }} startIcon={<TranslateIcon />}>{t('toolbar.language')}</Button>}
          {locale ==='en' && <Button onClick={() => changeLocale('pl')} color="inherit" sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }} startIcon={<TranslateIcon />}>{t('toolbar.language')}</Button>}


        </Toolbar>

      </AppBar>

    </Box>



  );







 }

 export default MainNavigation;
